"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/content`;
    }
    /**
     * Returns media content of an IVR prompt by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts/{promptId}/content
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyGreetings
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, { ...restRequestConfig, responseType: 'arraybuffer' });
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map